"use client";

import {
  UniversalStorageConstants,
  UniversalStorageUtils,
  useAppContext,
} from "@thriwe-2-0/thriwe-ui-utils";
import { redirect } from "next/navigation";
import { useEffect } from "react";
import { useClientConfigProvider } from "./config/client-config-provider";
import AppRoutes from "./constants/routes";

export default function withAuthRedirect(Component: any) {
  return function WrappedComponent(props: any) {
    const { config } = useClientConfigProvider();
    const {
      state: { user, memberships },
      instances: { apiRepository },
    } = useAppContext();

    const auth = !!UniversalStorageUtils.getItem(
      config?.nativeDataSavingType,
      UniversalStorageConstants.AUTH_TOKEN
    );
    console.log("redirect 1");
    useEffect(() => {
      if (auth) {
        if (!config?.userRegistration?.preLoginUserRegister) {
          console.log("redirect 2");
          return redirect(AppRoutes.dashboard);
        }

        // return redirect(AppRoutes.dashboard);
      }
    }, []);

    console.log("auth", auth);

    // if (auth && user?.data?.firstName && memberships?.data?.length) {
    //   console.log('insidenextauth')
    //   redirect(AppRoutes.dashboard);
    // }
    if (auth) {
      if (
        !config?.userRegistration?.preLoginUserRegister &&
        !config?.userRegistration?.isMembershipLinkedBefore
      ) {
        console.log("redirect 3");
        return redirect(AppRoutes.dashboard);
      }

      // return redirect(AppRoutes.dashboard);
    }

    return <Component {...{ heeelo: "nadeem", ...props }} />;
  };
}
